// removed by extract-text-webpack-plugin
module.exports = {"header":"header__-DkkD","active":"active__1hkj8"};


//////////////////
// WEBPACK FOOTER
// ./components/chat/style.css
// module id = ocPY
// module chunks = 11